// eslint-disable-next-line vue-component-file-name-match/match-component-import-name
import KaSelectBase from './KaSelect.vue';
import KaSelectGroup from './KaSelectGroup.vue';
import KaSelectOption from './KaSelectOption.vue';
import KaSelectVee from './KaSelectVee.vue';

export type { KaSelectEmits, KaSelectProps } from './KaSelect.vue';
export type {
  KaSelectGroupProps,
  KaSelectOptionProps,
  KaSelectSelection,
  KaSelectValue,
} from './types';

Object.assign(KaSelectBase, {
  Option: KaSelectOption,
  Group: KaSelectGroup,
});

export const KaSelect = KaSelectBase as typeof KaSelectBase & {
  readonly Option: typeof KaSelectOption;
  readonly Group: typeof KaSelectGroup;
};

export { KaSelectGroup, KaSelectOption, KaSelectVee };
